import { Redirect, useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

import { AuthContainer, SignUp } from '@fhs/auth';

export default function SignUpPage() {
  const { loginJwt } = useLocalSearchParams<{ loginJwt?: string }>();
  if (!loginJwt) {
    return <Redirect href="/v2/signin" />;
  }
  return (
    <>
      <Head>
        <title>Create Account - Firehouse Subs</title>
      </Head>
      <AuthContainer>
        <SignUp />
      </AuthContainer>
    </>
  );
}
